import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { addClass } from '@syncfusion/ej2-base';
import { CommonMethodService } from '../common-method.service';
import { EActionTypes, EElementTypes, EFeesCharges } from 'src/app/Shared/enum';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';


@Component({
    selector: 'app-feesCharges',
    templateUrl: 'feesChargesShared.component.html',
    styleUrls: ['feesChargesShared.component.scss'],
    standalone: false
})
export class FeesSharedComponentComponent implements OnInit, OnChanges {
  @Input() MoveInDate;
  @Input() dayEndFacilityDate;
  @Input() moduleType: number;
  @Input() feesAndChargesDataGrid = [];
  @Input() Rent;
  @Input() ProrateRent;
  @Input() ModifiedRentalForm:any;
  @Input() manualFeesAndCharges = [];
  @Output() saveFeesAndChargesEmit = new EventEmitter();
  @Input() effectiveDatesList = [];
  @Input() stopDatesList = [];
  @Input() rentRaiseSettings;
  @Input() NextBillingDate;
  @Input() PaidThroughDate;
  @Input() LatestURCToDate;
  @Input() FeesEditRight = false;
  @Input() feesMandatoryFields = null;
  @Input() Discount;
  @Input()duesFeesList;
  @Input() BillingTypeId;
  @Input() TotalSquareFoot;

  reasonRequired = false;
  eNumActionTypes = EActionTypes;
  eNumElementTypes = EElementTypes;
  stopDateAdjust = false;
  disableStopDate = false;
  maasterFeesAndCharges = [];
  masterFeesGridData = [];
  pageDirty = false;
  masterEffectiveDatesList = [];
  masterUnitLevelManualFeeList = [];
  stopdatedisable=false;
  feeRowCounter = 0;
  @ViewChild('feesModal', { static: false }) feesModal: ModalDirective;
  modalConfig = {
    backdrop: 'static',
    keyboard: false
  };

  constructor(private commonService: CommonMethodService, private modalWrapper: ModalWrapperService) { }

  ngOnInit(): void {
    this.feesAndChargesDataGrid.map(ele => {
      this.manualFeesAndCharges.map(item => {
        if (ele.selected == true && ele.FeesAndChargesId != item.FeesAndChargesId) {
          this.manualFeesAndCharges.push(ele);
        }
      })
      if (this.moduleType !== 2 || ele.ApplyManually) {
        ele.Amount = this.calculateFeesAmount(ele.InitialValue, ele.Type, this.getFeeProrate(ele));
      }
    })
    let arr = [];
    this.manualFeesAndCharges.forEach((ele) => {
      let index = arr.findIndex(o => o.FeesAndChargesId === ele.FeesAndChargesId);
      if (index === -1) {
        arr.push(ele);
      }
    });
    this.manualFeesAndCharges = arr;
    this.maasterFeesAndCharges = JSON.parse(JSON.stringify(arr));
    this.masterFeesGridData = JSON.parse(JSON.stringify(this.feesAndChargesDataGrid));
    this.masterUnitLevelManualFeeList = JSON.parse(JSON.stringify(this.manualFeesAndCharges));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['manualFeesAndCharges']) {
      let arr = [];
      if (!this.maasterFeesAndCharges.length && this.manualFeesAndCharges) {
        this.manualFeesAndCharges.forEach((ele) => {
          let index = arr.findIndex(o => o.FeesAndChargesId === ele.FeesAndChargesId);
          if (index === -1) {
            arr.push(ele);
          }
        });
        this.maasterFeesAndCharges = JSON.parse(JSON.stringify(arr));
        this.masterUnitLevelManualFeeList = JSON.parse(JSON.stringify(this.manualFeesAndCharges));
      }
    }

    if (changes && changes['effectiveDatesList']) {
      let stopArr = [];
      let arr = JSON.parse(JSON.stringify(this.effectiveDatesList));
      arr.forEach((ele) => {
        ele = new Date(ele);
        ele.setDate(ele.getDate() - 1);
        stopArr.push(ele);
      });
      this.stopDatesList = stopArr;
    }

    if (changes && changes['feesAndChargesDataGrid']) {
      if (this.feesAndChargesDataGrid && (this.moduleType == 3 || this.moduleType == 1)) {
        this.masterFeesGridData = JSON.parse(JSON.stringify(this.feesAndChargesDataGrid));
      }
    }
  }
  get newFees() {
  return this.feesAndChargesDataGrid.filter(x => !x.RecurringFeeId);
}

get futureFees() {
  return this.feesAndChargesDataGrid.filter(x => x.RecurringFeeId);
}

  addFees() {
    var obj = {
      _rowId: ++this.feeRowCounter,
      AppliedFeeDueID: 0,
      RecurringFeeId: 0,
      AppliedFor: 0,
      FeesAndChargesId: 0,
      Name: "",
      OneTimeFees: false,
      EffectiveDate: "",
      StopDate: null,
      Type: 0,
      Value: 0,
      Amount: 0,
      Notes: null,
      Stopped: false,
      edit: false,
      ApplyManually: true,
      IsError: false,
      AllowToOverride: false
    }
    this.feesAndChargesDataGrid.push(obj);

    let arr = [];
    this.manualFeesAndCharges.forEach((ele) => {
      let index = arr.findIndex(o => o.FeesAndChargesId === ele.FeesAndChargesId);
      if (index === -1) {
        arr.push(ele);
      }
    });
    this.manualFeesAndCharges = arr;
  }

  //////Fees and charges ///////////////
  checkFeesCharges(val, feeId, feeObj) {
    this.pageDirty = true;
    var newObject = this.feesAndChargesDataGrid.find(o => (parseInt(o.FeesAndChargesId) === parseInt(feeId, 10) &&
      (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
      (feeObj.RecurringFeeId == o.RecurringFeeId)));
    newObject.Notes = '';
    newObject['IsError'] = false;
    newObject['Value'] = newObject.InitialValue;
    if (!val) {
      newObject.Stopped = true;
      newObject.edit = true;
      newObject['Modified'] = true;
      if (newObject.RecurringFeeId) {
        newObject['feeStopUpdated'] = true;
      }
      if (newObject) {
        newObject.Amount = this.calculateFeesAmount(newObject.Value, newObject.Type,this.getFeeProrate(newObject));
        if (newObject.OneTimeFees) {
                newObject.StopDate = null;
          newObject['disableStopDate'] = true;
        } else {
          newObject['disableStopDate'] = false;
          newObject.StopDate = null;
        }

      }
    } else {
      newObject.Stopped = false;
      newObject.StopDate = null;
      newObject['disableStopDate'] = false;
      if ((newObject.Value == null || newObject.Value < 0) && newObject.AllowToOverride) {
        newObject.IsError = true;
      } else if ((newObject.Value > newObject.MaxValue || newObject.Value < newObject.MinValue) && newObject.AllowToOverride &&
        !(newObject.MaxValue == 0 && newObject.MinValue == 0)) {
        newObject.IsError = true;
      } else {
        newObject.IsError = false;
      }
    }

    if (this.moduleType == 2) {
      this.saveFeesAndCharges();
    }
  }

  checkFeesChargesDisable() {
      const indexError = this.feesAndChargesDataGrid.findIndex(fee => (fee.IsError == true && fee.AllowToOverride));
      if (indexError != -1) {
        return true;
      }
    if (!this.pageDirty) {
        return true;
      }
    if (this.moduleType == 3) {
      const index = this.feesAndChargesDataGrid.findIndex((ele) =>
        !ele.selected && ele.FeesAndChargesId != 0 && ((ele.Notes && ele.Notes.trim() === '') || !ele.Notes));
      if (index != -1) {
        return true;
      }
      return false;
    }
  }

  getFeeProrate(fee: any) {
    return fee && fee.IsReservationFee ? false : fee?.Prorate;
  }

  calculateFeesAmount(value, type,Prorate?) {
     var Discount = this.Discount;
    let amt = 0;
    let changedVal = value == null ? 0 : parseFloat(value);
    if (changedVal === 0) {
      return amt;
    }
    if (this.moduleType == 3) {
      const rent = parseFloat(this.Rent) || 0;
      const discount = parseFloat(this.Discount) || 0;
      const parsedProrateRent = parseFloat(this.ProrateRent);
      const prorateRent = Number.isNaN(parsedProrateRent) ? rent : parsedProrateRent;
      if (type === EFeesCharges.Percentage) {
        amt = rent * (changedVal / 100);
      } else if (type === EFeesCharges.Fixed) {
        amt = changedVal;
      } else if (type === EFeesCharges.PricePerSquareFoot) {
        if (this.TotalSquareFoot == null || this.TotalSquareFoot === '') {
          return null;
        }
        const squareFoot = Number(this.TotalSquareFoot);
        if (!Number.isFinite(squareFoot)) {
          return null;
        }
        amt = changedVal * squareFoot;
      } else {
        if (Prorate) {
          amt = (prorateRent - discount) * (changedVal / 100);
        } else {
          let adjustedDiscount = 0;
          if (prorateRent > 0) {
            adjustedDiscount = (rent * discount) / prorateRent;
          }
          amt = (rent - adjustedDiscount) * (changedVal / 100);
        }
        return parseFloat(amt.toFixed(2));
      }
      if (Prorate && this.BillingTypeId && this.MoveInDate) {
        amt = this.commonService.getProratedValue(this.BillingTypeId, amt, this.MoveInDate, 0, null);
      }
      return parseFloat(amt.toFixed(2));
    }
    if (type === EFeesCharges.Percentage) {
      amt = (Prorate?this.ProrateRent:parseFloat(this.Rent)) * (changedVal / 100);
      return amt.toFixed(2);
    } else if (type === EFeesCharges.Fixed) {
      amt = changedVal;
      return amt.toFixed(2);
    } else if (type === EFeesCharges.PricePerSquareFoot) {
      if (this.TotalSquareFoot == null || this.TotalSquareFoot === '') {
        return null;
      }
      const squareFoot = Number(this.TotalSquareFoot);
      if (!Number.isFinite(squareFoot)) {
        return null;
      }
      amt = changedVal * squareFoot;
      return amt.toFixed(2);
    }
    else{
      if(Prorate){
           amt=(parseFloat(this.ProrateRent)-Discount)*(changedVal / 100);
      }else{
        if(this.ProrateRent > 0){
        Discount=(this.Rent * Discount)/this.ProrateRent;
        }else{
          Discount = 0;
        }
         amt=(parseFloat(this.Rent) - Discount)*(changedVal / 100); 
      }
     
      return this.round2AwayFromZero(amt).toFixed(2);
    }
  }

  prorateFeeAtMoveIn(feeObj) {
    let amount = 0;
    let today = new Date();
    let selDate = new Date(feeObj.EffectiveDate);
    if (feeObj && today.getFullYear() === selDate.getFullYear()
      && today.getDate() === selDate.getDate()
      && today.getMonth() === selDate.getMonth()
      && feeObj.Prorate
      && feeObj.Type === 183) {
      let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
      let effDate = selDate.getDate();
      let remainingDays = (lastDay - effDate) + 1;
      if (remainingDays !== 0) {
        amount = parseFloat(((feeObj.Amount / lastDay) * remainingDays).toFixed(2));
        return amount;
      }
    }
    return feeObj.Amount;
  }

  feeschargesChanged(fId, row) {
row.FeesAndChargesId = fId;
    if (fId !== '0') {
      this.pageDirty = true;
      var mainObject = this.manualFeesAndCharges.find(o => o.FeesAndChargesId === parseInt(fId, 10));
      var newObject = JSON.parse(JSON.stringify(mainObject));
      var index = this.feesAndChargesDataGrid.findIndex(o => (parseInt(o.FeesAndChargesId, 10) === parseInt(fId, 10) &&
        !o.AppliedFeeDueID && !o.RecurringFeeId));
      newObject['newlyAdded'] = true;
      newObject.selected = true;
      newObject['Modified'] = true;
      newObject.IsError = false;
      newObject.Value = newObject.InitialValue;
      this.feesAndChargesDataGrid[index] = newObject;
      newObject.Amount = this.calculateFeesAmount(newObject.Value, newObject.Type, this.getFeeProrate(newObject));
      let today = this.getFacilityToday();
      let Dateindex = this.effectiveDatesList.findIndex(o => o.getDate() === today.getDate()
        && o.getMonth() === today.getMonth());
      if (newObject.OneTimeFees == true) {
        newObject.EffectiveDate = today;
        let datetemp = this.commonService.getTimeZoneOffSetDate(newObject.EffectiveDate);
        datetemp.setHours(0, 0, 0);
        let todayTemp = new Date(today);
        todayTemp.setHours(0, 0, 0);
        if (todayTemp >= new Date(this.commonService.getFormattedDate(this.MoveInDate))) {
          this.effectiveDatesList.push(datetemp);
        }      
      } else if (Dateindex != -1) {
        this.effectiveDatesList.splice(Dateindex, 1);
      }
      newObject.EffectiveDate = today;
      let todayCompare = new Date(today);
      todayCompare.setHours(0, 0, 0);
      if (todayCompare < new Date(this.commonService.getFormattedDate(this.MoveInDate))) {
        newObject.EffectiveDate = this.commonService.getTimeZoneOffSetDate(this.NextBillingDate);
      }
      this.manualFeesAndCharges=JSON.parse(JSON.stringify(this.manualFeesAndCharges));
      this.manualFeesAndCharges.map((item) => {
             let obj = this.feesAndChargesDataGrid.find((o) => o.FeesAndChargesId == item.FeesAndChargesId);
        if (!obj) {
          item['selected'] = false;
          item['newlyAdded'] = false;
          item['Modified'] = true;
        } else {
          item['selected'] = true;
          item['newlyAdded'] = true;
          item['Modified'] = true;
        }
      })

      if ((newObject.Value == null || newObject.Value < 0) && newObject.AllowToOverride) {
        newObject.IsError = true;
      } else if ((newObject.Value > newObject.MaxValue || newObject.Value < newObject.MinValue) && newObject.AllowToOverride &&
        !(newObject.MaxValue == 0 && newObject.MinValue == 0)) {
        newObject.IsError = true;
      } else {
        newObject.IsError = false;
      }
      if (this.moduleType == 2) {
        let indexMaster = this.masterFeesGridData.findIndex(o => o.FeesAndChargesId == parseInt(fId, 10) &&
          !o.AppliedFeeDueID && !o.RecurringFeeId);
        if (indexMaster == -1) {
          this.masterFeesGridData.push(newObject);
        } else {
          this.masterFeesGridData[indexMaster] = JSON.parse(JSON.stringify(newObject));
        }
        this.saveFeesAndChargesEmit.emit(this.feesAndChargesDataGrid);
      }
    } else {// checl required
      this.manualFeesAndCharges = JSON.parse(JSON.stringify(this.masterUnitLevelManualFeeList));
      var newObject = this.manualFeesAndCharges.find(o => o.FeesAndChargesId === parseInt(fId, 10));
      newObject.Value = newObject.InitialValue;
    }
    this.masterUnitLevelManualFeeList = JSON.parse(JSON.stringify(this.manualFeesAndCharges));
  }

  feesChanged(val, fId, feeObj) {
    let newObject = this.feesAndChargesDataGrid.find(o => (o.FeesAndChargesId === parseInt(fId, 10) &&
      (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
      (feeObj.RecurringFeeId == o.RecurringFeeId)));
    newObject.edit = true;
    newObject.Amount = this.calculateFeesAmount(newObject.Value, newObject.Type, this.getFeeProrate(newObject));
    this.onNotesEntered(newObject.Notes, fId, newObject);
    if ((newObject.Value == null || newObject.Value < 0) && newObject.AllowToOverride) {
      newObject.IsError = true;
    } else if ((newObject.Value > newObject.MaxValue || newObject.Value < newObject.MinValue) && newObject.AllowToOverride &&
      !(newObject.MaxValue == 0 && newObject.MinValue == 0)) {
      newObject.IsError = true;
    } else {
      newObject.IsError = false;
    }
    if (this.moduleType == 2) {
      this.saveFeesAndChargesEmit.emit(this.feesAndChargesDataGrid);
    }
  }

  effectiveDateChange(val, fId, feeObj) {
    let newObject = this.feesAndChargesDataGrid.find(o => (o.FeesAndChargesId === parseInt(fId, 10) &&
      (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
      (feeObj.RecurringFeeId == o.RecurringFeeId)));
    newObject['edit'] = true;
    if (this.moduleType == 2 && val.value) {
      newObject.EffectiveDate = val.value;
    } else if (this.moduleType == 1 && val) {
      newObject.EffectiveDate = val;
    }
    this.clearStaleStopDateForNewRecurringFee(newObject, val?.value ?? val);
    this.onNotesEntered(newObject.Notes, fId, newObject);

    let masterObject = this.masterFeesGridData.find(o => o.FeesAndChargesId === parseInt(fId, 10) &&
      (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
      (feeObj.RecurringFeeId == o.RecurringFeeId));
    if (masterObject && masterObject.EffectiveDate && ((this.moduleType == 2 && val && val.value && val.event) || (this.moduleType == 1 && val))) {
      let date = this.commonService.getTimeZoneOffSetDate(masterObject.EffectiveDate)
      date.setHours(0, 0, 0);
      if (val.value.getTime() != date.getTime()) {
        newObject['Modified'] = true;
      }
    }
    if (this.moduleType == 2 && val.isInteracted) {
      this.saveFeesAndCharges();
    }
  }

  StopDateChange(val, fId, feeObj) {
    if (val && val.isInteracted) {
      let newObject = this.feesAndChargesDataGrid.find(o => o.FeesAndChargesId === parseInt(fId, 10) &&
        (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
        (feeObj.RecurringFeeId == o.RecurringFeeId));
      if (newObject) {
        newObject.edit = true;
        if (val.value || val.value == null) {
          newObject.StopDate = val.value;
        const isCalendarSelection = val?.event?.type === 'click';

        if (isCalendarSelection && val.value) {
        newObject.stopDateInputText = '';
        newObject.showStopDateError = false;
        }
        }
        if (newObject.StopDate) {
          newObject.StopDate.setHours(0, 0, 0);
        }
        newObject.Stopped = !!newObject.StopDate;
        newObject['feeStopUpdated'] = true;
        newObject['Modified'] = true;
        newObject['FeeStopNullified'] = !!newObject.RecurringFeeId && !newObject.StopDate && !!newObject.OriginalStopDate;
        this.onNotesEntered(newObject.Notes, fId, newObject);
      }
      if (this.moduleType == 2) {
        this.saveFeesAndCharges();
      }
    }
  }

disableOption(feeId: number): boolean {

  return this.feesAndChargesDataGrid.some(o =>
    Number(o.FeesAndChargesId) === Number(feeId) && !o.RecurringFeeId
  );

}
  onNotesEntered(val, fId, feeObj) {
    let newObject = this.feesAndChargesDataGrid.find(o => (parseInt(o.FeesAndChargesId) === parseInt(fId, 10) &&
      (feeObj.AppliedFeeDueID == o.AppliedFeeDueID) &&
      (feeObj.RecurringFeeId == o.RecurringFeeId)));
    this.pageDirty = newObject.FeesAndChargesId > 0 ? true : false; 
    if (val && val.trim() === '') {
      newObject.edit = true;
    } else {
      newObject.edit = false;
    }
    if (newObject) {
      if (newObject.StopDate) {
        newObject.edit = false;
      } else {
        newObject.edit = true;
      }
    }
  }

  onLoadEffectiveDate(args: any) {
    let rentRaiseDays = 0;
    let date = this.dayEndFacilityDate ? new Date(this.dayEndFacilityDate) : new Date();
    let effDate;
    if (this.NextBillingDate) {
      date = this.commonService.getTimeZoneOffSetDate(this.NextBillingDate);
      let paidThruDate = this.commonService.getTimeZoneOffSetDate(this.PaidThroughDate);
      if (paidThruDate > date) {
        effDate = paidThruDate;
      } else {
        effDate = date;
      }
    }

    let Dateindex = this.effectiveDatesList.findIndex(o => o.getDate() === args.date.getDate()
      && o.getMonth() === args.date.getMonth());
    if (Dateindex === -1) {
      args.isDisabled = true;
    } else {
      addClass([args.element], ['effectiveCls']);
      args.element.firstElementChild.setAttribute('title', 'Next Billing Date');
      args.element.setAttribute('title', 'Next Billing Date');
    }
    if (effDate) {
      effDate.setDate(date.getDate() - 1);
    }
    if (this.NextBillingDate) {
      let urcStart = this.commonService.getTimeZoneOffSetDate(this.NextBillingDate);
      urcStart.setHours(0, 0, 0, 0);
      let nextPeriodStart = new Date(urcStart);
      nextPeriodStart.setMonth(nextPeriodStart.getMonth() + 1);
      nextPeriodStart.setHours(0, 0, 0, 0);
      args.date.setHours(0, 0, 0, 0);

      if (args.date > urcStart && args.date < nextPeriodStart) {
        args.isDisabled = true;
      }

      if (args.date.getTime() === nextPeriodStart.getTime()) {
        args.isDisabled = false;
      }

    }
    let today = this.dayEndFacilityDate ? new Date(this.dayEndFacilityDate) : new Date();
    let tempdate = this.commonService.getTimeZoneOffSetDate(today);
    tempdate.setHours(0, 0, 0);
    args.date.setHours(0, 0, 0);

    if (args.date < effDate) {
      args.isDisabled = true;
    }
    if (Dateindex != -1 && args.date.getDate() === tempdate.getDate() && args.date.getMonth() === tempdate.getMonth()) {
      args.isDisabled = false;
    }
  }

  onLoadStopDate(args: any, item) {
    this.stopdatedisable=false;
    let effectiveDate: Date;
    let tempEffDate: Date;
    if (item.UfcToDate) {
      effectiveDate =new Date(item.UfcToDate);
      effectiveDate.setHours(0, 0, 0, 0); 
      tempEffDate = new Date(effectiveDate.toISOString());
   
    } else 
    {
      effectiveDate = item.EffectiveDate;
      tempEffDate = new Date(effectiveDate);
    }
    let nextDay = new Date(args.date);
    nextDay.setDate(args.date.getDate() + 1);
    let Dateindex = this.stopDatesList.findIndex(o => o.getDate() === args.date.getDate()
      && o.getMonth() === args.date.getMonth());
    if (Dateindex === -1||effectiveDate &&
      (args.date.getTime() < tempEffDate.getTime())) {
      args.isDisabled = true;
    }
    else {
      addClass([args.element], ['effectiveCls']);
      args.element.firstElementChild.setAttribute('title', 'Next Stop Date');
      args.element.setAttribute('title', 'Next Stop Date');
    }
   
    if ( !item.UfcToDate) {
      if (nextDay.getDate() === tempEffDate.getDate() &&
          nextDay.getMonth() === tempEffDate.getMonth() &&
          nextDay.getFullYear() === tempEffDate.getFullYear() &&
          (item.OneTimeFees || this.isFutureUnstartedRecurringFee(item, tempEffDate))) {
        args.isDisabled = false;
      } else {
        if(item.OneTimeFees) {
          args.isDisabled = true;

        }
      }
    }
  }


  isFutureUnstartedRecurringFee(item: any, effectiveDate: Date): boolean {
    if (!item || item.OneTimeFees || item.UfcToDate || !effectiveDate || isNaN(effectiveDate.getTime())) {
      return false;
    }
    const effDate = new Date(effectiveDate);
    effDate.setHours(0, 0, 0, 0);

    const today = this.commonService.getTimeZoneOffSetDate(this.getFacilityToday());
    if (!today) {
      return false;
    }
    today.setHours(0, 0, 0, 0);
    if (effDate.getTime() <= today.getTime()) {
      return false;
    }

    if (this.PaidThroughDate) {
      const paidThru = this.commonService.getTimeZoneOffSetDate(this.PaidThroughDate);
      paidThru?.setHours(0, 0, 0, 0);
      if (paidThru && effDate.getTime() <= paidThru.getTime()) {
        return false;
      }
    }
    return true;
  }

  clearStaleStopDateForNewRecurringFee(feeObj: any, newEffectiveDate: Date): void {
    if (!feeObj || feeObj.RecurringFeeId || feeObj.OneTimeFees || !feeObj.StopDate ||
      !(newEffectiveDate instanceof Date) || isNaN(newEffectiveDate.getTime())) {
      return;
    }
    const effDate = new Date(newEffectiveDate);
    effDate.setHours(0, 0, 0, 0);
    const stopDate = new Date(feeObj.StopDate);
    stopDate.setHours(0, 0, 0, 0);
    const dayBeforeEffective = new Date(effDate);
    dayBeforeEffective.setDate(effDate.getDate() - 1);

    const stillValid = stopDate.getTime() >= effDate.getTime() ||
      (stopDate.getTime() === dayBeforeEffective.getTime() && this.isFutureUnstartedRecurringFee(feeObj, effDate));
    if (!stillValid) {
      feeObj.StopDate = null;
      feeObj.Stopped = false;
      feeObj.stopDateInputText = '';
      feeObj.showStopDateError = false;
    }
  }

  cancelFees() {
    this.pageDirty = false;
    this.feesAndChargesDataGrid = JSON.parse(JSON.stringify(this.masterFeesGridData));
  }

  saveFeesAndCharges() {
    if (this.moduleType == 2) {
      this.pageDirty = false;
    }
    this.masterFeesGridData = JSON.parse(JSON.stringify(this.feesAndChargesDataGrid));
    this.saveFeesAndChargesEmit.emit(this.feesAndChargesDataGrid);
  }

  isReasonAdded(item) {
    if (this.reasonRequired && item.selected && item.Modified && ((item.Notes && item.Notes.trim() === '') || !item.Notes)) {
      return true;
    }
    return false;
  }

  setMandatory() {
    if (this.feesMandatoryFields) {
      this.reasonRequired = this.feesMandatoryFields.Form.ListOfProperties.find((ele) => ele.Name == 'Notes').Required;
    }
  }

  openModal() {
    if (this.feesModal) {
      this.modalWrapper.openDirective(this.feesModal);
    }
  }

  closeModal() {
    if (this.feesModal) {
      this.feesModal.hide();
    }
  }

  disableForNoReason() {
    let stopFeeNoReason = this.isReasonEnteredOnStop();
    let notesRequiredNoReason = this.reasonRequired && this.feesAndChargesDataGrid.some((item) => item.selected && item.Modified && ((item.Notes && item.Notes.trim() === '') || !item.Notes));
    return stopFeeNoReason || notesRequiredNoReason;
  }
  disableForNoEffectiveDate()
  {
    const index = this.feesAndChargesDataGrid.findIndex((ele) => ele.EffectiveDate==null);
    if(index != -1)
  {
    return true;
  } else
  return false;
  }

  disableForNoStopDate(): boolean {
  return this.feesAndChargesDataGrid.some(x => x.showStopDateError);
}
  isReasonEnteredOnStop() {
    const index = this.feesAndChargesDataGrid.findIndex((ele) => ele.Stopped && (!ele.RecurringFeeId || (ele.RecurringFeeId && ele.feeStopUpdated)) && ((ele.Notes && ele.Notes.trim() === '') || !ele.Notes));
    if (index != -1) {
      return true;
    }
    return false;
  }
  disableStopDates(item)
  {
    if(item.disableStopDate || !item.FeesAndChargesId||item.disableDatePicker)
    {
      return true;
    }else
    return false
  }
  getFacilityToday(): Date {
    return this.dayEndFacilityDate? new Date(this.dayEndFacilityDate): new Date();
  }
  round2AwayFromZero(value: number): number {
    const factor = 100; if (value >= 0) {
      return Math.floor(value * factor + 0.5) / factor;
    }
    else {
      return Math.ceil(value * factor - 0.5) / factor;

    }
  }
}
